module.exports = __webpack_public_path__ + "img/down07.68c44a2d.png";